import React from 'react';
import styled from 'styled-components';
import { media } from '@marketing-site/styles';
import { StepComponent } from './StepComponent';
import { Stack, Typography } from '@mui/material';
import { IImageTextDescription } from '@marketing-site/types';
import richTextToHtml from '@marketing-site/utils/richTextRenderer';

const interviewSteps = [
  {
    stepNumber: 1,
    title: 'Intro Call',
    description: 'A brief conversation about the role and your experience.',
  },
  {
    stepNumber: 2,
    title: 'Competency Screening',
    description: 'Role-specific assessments to evaluate technical skills.',
  },
  {
    stepNumber: 3,
    title: 'Interview Loop',
    description: 'In-depth interviews with team members.',
  },
  {
    stepNumber: 4,
    title: 'Bar Raiser Interview',
    description:
      'Final discussion with a senior leader to ensure alignment with our culture and standards.',
  },
];

export const InterviewProcess = (props: IImageTextDescription) => {
  return (
    <Stack
      gap={{ mobile: 400, desktop: 600 }}
      margin={'0 auto'}
      pt={'64px'}
      width={'92%'}
      maxWidth={'1100px'}
    >
      <div>
        <Header>{props.headline}</Header>
        <Subheading>{props.preHeadline}</Subheading>
      </div>
      <Stack gap={600} direction={{ mobile: 'column', desktop: 'row' }}>
        <Stack gap={600}>
          <Stack gap={300}>
            {interviewSteps.map((step) => (
              <StepComponent
                key={step.stepNumber}
                stepNumber={step.stepNumber}
                title={step.title}
                description={step.description}
              />
            ))}
          </Stack>
          <Description>
            <Typography
              variant={'body1'}
              fontSize={16}
              fontWeight={400}
              lineHeight={24}
            >
              {richTextToHtml(props.textDescription?.json)}
            </Typography>
            <LearnMore href={props.actionLink?.url}>
              {props.actionLink?.text}
            </LearnMore>
          </Description>
        </Stack>
        <RightImage src={props.image?.url} />
      </Stack>
    </Stack>
  );
};

const Header = styled.h4`
  font-size: 32px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 8px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
  `};
`;

const Subheading = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  > p {
    > p {
      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
    }
  }
`;

const LearnMore = styled.a`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`;

const RightImage = styled.img`
  object-fit: contain;
  width: 100%;
  max-height: 420px;
  height: auto;
  ${media.tablet`
    height: 176px;
    widht: auto;
  `};
`;
